import priceTypes from '../constants/priceTypes';

type GetSharePriceProps = {
  price: number;
  priceType: string;
  sharesToTransfer: number;
  societySharesCount: number;
};

export const getSharePrice = ({
  price,
  priceType,
  sharesToTransfer,
  societySharesCount,
}: GetSharePriceProps): number => {
  const FIXED = priceTypes[0].value;
  const BY_SHARE = priceTypes[1].value;
  const BY_SOCIETY = priceTypes[2].value;

  switch (priceType) {
    case FIXED:
      return sharesToTransfer ? price / sharesToTransfer : 0;
    case BY_SHARE:
      return price;
    case BY_SOCIETY:
      return societySharesCount ? price / societySharesCount : 0;
    default:
      return 0;
  }
};
